import React, {useEffect} from "react";
import { useLang } from '../contexts/LanguageContext';
import NavbarHome from '../components/NavbarIndex';
import { Container } from "react-bootstrap";
import { useLocation } from 'react-router-dom';
import FaqAccordion from "../components/Index/FaqAccordion";
import FormQuestion from "../components/FormQuestion";
import Footer from '../components/Footer';

export default function CustomerSupport() {

  // Variable de traducción
  const { t } = useLang();

  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace('#', '');
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location]);

  return (
    <div>
      <NavbarHome static_page="true" />
        <Container>
          <div className="header_st">
            <h1>{t("CUSTOMER_SUPPORT_TITLE")}</h1>
          </div>
          <div className="content_st">
            <p>{t("CUSTOMER_SUPPORT_TEXT")}</p>
            <hr />
            <FaqAccordion isExtended={true} />
            <br />
            <h1 id="form">{t("CONTACT_FORM_TITLE")}</h1>
            <p>{t("CONTACT_FORM_DESC")}</p>
            <FormQuestion formName="CustomerSupport"/>
          </div>
        </Container>
      <Footer />
    </div>
  );
}
